import React from "react";
import classnames from "classnames";

const Div = props => {
  return (
    <div
      style={props.styles}
      id={props.id}
      className={classnames({
        [props.className]: props.className,
        [props.name?.replace(/,/g, "-")]: props.name,
        [props.type]: props.type,
      })}
    >
      {props.children}
    </div>
  );
};

export default Div;
